import ReactionWebSocketSubscriber from './reaction.websocket.subscriber'
import PresentationWebSocketSubscriber from './presentation.websocket.subscriber'
import SlideOptionWebSocketSubscriber from './slide-option.websocket.subscriber'

function init(socket) {
  const reactionWebSocketSubscriber = new ReactionWebSocketSubscriber(socket)
  const presentationWebSocketSubscriber = new PresentationWebSocketSubscriber(socket)
  const slideOptionWebSocketSubscriber = new SlideOptionWebSocketSubscriber(socket)
  reactionWebSocketSubscriber.init()
  presentationWebSocketSubscriber.init()
  slideOptionWebSocketSubscriber.init()
}

const MainWebSocketSubscriber = {
  init,
}

export default MainWebSocketSubscriber
